const DocMenuConfig = [
  {
    heading: "Laporan",
    route: "/laporan",
    pages: [
      {
        heading: "Laporan Perkhidmatan",
        name: "laporan_perkhidmatan",
        route: "/laporan/perkhidmatan",
        svgIcon: "/media/icons/duotune/general/gen022.svg",
        fontIcon: "bi-archive",
      },
      {
        heading: "Laporan Peperiksaan",
        name: "laporan_peperiksaan",
        route: "/laporan/peperiksaan",
        svgIcon: "/media/icons/duotune/general/gen022.svg",
        fontIcon: "bi-archive",
      },
      {
        heading: "Laporan Pentadbiran Sistem",
        name: "laporan_pentadbiran",
        route: "/laporan/pentadbir-sistem",
        svgIcon: "/media/icons/duotune/general/gen022.svg",
        fontIcon: "bi-archive",
      },
    ],
  },
];

export default DocMenuConfig;
